goog.provide("shadow.js.shim.module$$embedpdf$react$runtime");
goog.provide("module$shadow_js_shim_module$$embedpdf$react$runtime");
shadow.js.shim.module$$embedpdf$react$runtime = shadow.js.nativeProvides["@embedpdf/react/runtime"] = shadow$bridge("@embedpdf/react/runtime");
module$shadow_js_shim_module$$embedpdf$react$runtime.default = shadow.js.shim.module$$embedpdf$react$runtime;
